import { useState } from 'react';
import { ExpandAccordion } from './expand-accordion';
import styles from '../expand.module.scss';

// Initial visible count; the rest fold behind "Show more".
const DEFAULT_VISIBLE = 8;

// The document's survey areas ("Applicable Areas") as a collapsible section,
// mirroring the collapsed card column. The body is a fixed-height scroll box so a
// long list scrolls inside the accordion; the first `visible` areas show and
// "Show more +(N)" reveals the rest in place. Renders nothing with no areas.
export const ApplicableAreasSection = ({
  areas,
  openSignal,
  visible = DEFAULT_VISIBLE,
}: {
  areas: string[];
  openSignal?: { open: boolean };
  visible?: number;
}) => {
  const [showAll, setShowAll] = useState(false);
  if (areas.length === 0) return null;
  const shown = showAll ? areas : areas.slice(0, visible);
  const remaining = areas.length - shown.length;
  return (
    <ExpandAccordion title="Applicable Areas" openSignal={openSignal}>
      <ul className={styles.areaScrollList}>
        {shown.map((area, i) => (
          <li key={i}>{area}</li>
        ))}
      </ul>
      {remaining > 0 && (
        <button
          type="button"
          className={styles.showMore}
          onClick={(e) => {
            e.stopPropagation();
            setShowAll(true);
          }}
        >
          Show more +({remaining})
        </button>
      )}
    </ExpandAccordion>
  );
};
